export enum SepaSchemeEnum {
  CORE = 'CORE',
  B2B = 'B2B',
}

